import { getValue } from './commons';
import T from '../locales';
var i18nText = {};
export var setLocale = function setLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  i18nText = T[locale] || T.en;
};
export var translate = function translate(key, defaultValue) {
  return getValue(i18nText, key, defaultValue);
};